import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import { walkFields } from '@core-engine/schema/field-helpers/walking/walk-fields.js'

export function schemaNeedsMarkdownRenderer(loaded: LoadedSchema): boolean {
  if (loaded.type === 'form') return false

  let needsRenderer = false

  walkFields(loaded.schema.fields, (field) => {
    if ((field.type === 'richtext' || field.type === 'markdown') && field.output === 'html') {
      needsRenderer = true
    }
  })

  return needsRenderer
}
